import { useMutation } from "@/compat/reactQuery";
import riskAssessmentAiService from "../../services/riskAssessmentAiService";

const useScanRiskAssessmentDocument = () =>
    useMutation(riskAssessmentAiService.scanDocument);

export default useScanRiskAssessmentDocument;
